export default "__VITE_ASSET__9QlmBEYc__"